import apiClient from './apiClient';
import { Class } from '../types/classes';

export const classApi = {
  // Get all classes for the current user
  getClasses: async (): Promise<Class[]> => {
    const response = await apiClient.get('/api/classes');
    return response.data.classes;
  },

  // Get a specific class by ID
  getClass: async (classId: string): Promise<Class> => {
    const response = await apiClient.get(`/api/classes/${classId}`);
    return response.data;
  },

  // Create a new class
  createClass: async (name: string): Promise<Class> => {
    const response = await apiClient.post('/api/classes', { name });
    return response.data;
  },

  // List all classes in catalog (public, works for guests)
  getAllClasses: async (): Promise<Class[]> => {
    const response = await apiClient.get('/api/classes/all');
    return response.data.classes;
  },
  
  // Get class details (public for guests, full for members)
  getClassPublic: async (classId: string): Promise<Class> => {
    const response = await apiClient.get(`/api/classes/${classId}`);
    return response.data;
  },

  // Join a class by id
  joinClassById: async (classId: string): Promise<Class> => {
    const response = await apiClient.post('/api/classes/join', { class_id: classId });
    return response.data;
  },

  // Leave a class
  leaveClass: async (classId: string): Promise<{ status: string }> => {
    const response = await apiClient.delete(`/api/classes/${classId}/leave`);
    return response.data;
  },
};
